const BRAZE = {
    SUPER_PROPERTIES: {
        USER_ID: 'User ID',
        OPERATOR: 'Operator',
        SUBSCRIPTION_START_DATE: 'Subscription Start Date',
        SUBSCRIPTION_END_DATE: 'Subscription End Date',
        DEVICE_TYPE: 'Device Type',
        STATUS: 'Status',
        SUBSCRIPTION_PACKAGES: 'Subscription Packages',
    },
    PROPERTIES: {
        VOD_TYPE: 'VOD Type',
        VOD_CATEGORY: 'VOD Category',
        MOVIE_NAME: 'Movie Name',
        TV_SHOW_NAME: 'TV Show Name',
        SEASON_NAME: 'Season Name',
        EPISODE_NAME: 'Episode Name',
        GENRE: 'Genre',
        LANGUAGE: 'Language',
        PRICE: 'Price',
        CHANNEL_NAME: 'Channel Name',
        PROGRAM_NAME: 'Program Name',
        PROGRAM_TYPE: 'Program Type',
        CHANNEL_CATEGORY: 'Channel Category',
        DURATION: 'Durations',
    },
    EVENTS: {
        APP_OPEN: 'App - Open',
        LOGIN: 'Login',
        APP_SIGNOUT: 'App - Sign out',
        PROGRAM_WATCHED: 'Program - Watched',
        VOD_WATCHED: 'VOD - Watched',
        TVOD_PURCHASE: 'TVOD - Purchase',
    },
};

export { BRAZE };
